import React from "react";

/**
 * @component CopyIcon
 * @description
 *
 * The React Icon component is a visual element that displays an icon to represent a concept, object, or action.
 * The Icon component is
 * customizable, allowing for variations in size, color, and style to fit the needs of the application.
 *
 *
 * @example
 * return (
 *   <CopyIcon className="mr-2" />
 * )
 *
 * @see
 * https://system.activecollab.com/?path=/story/foundation-icons-icons--icons
 * @see
 * https://design.activecollab.com/docs/foundations/icons
 */
const CopyIcon = React.forwardRef(
  (props: React.SVGProps<SVGSVGElement>, svgRef?: React.Ref<SVGSVGElement>) => (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="CopyIcon"
      fill="var(--color-theme-600)"
      focusable={false}
      ref={svgRef}
      {...props}
    >
      <path
        d="M20 20V8H8v12h12m2 0a2 2 0 01-2 2H8a2 2 0 01-2-2V8c0-1.11.89-2 2-2h12a2 2 0 012 2v12M4 16H2V4a2 2 0 012-2h13v2H4v12z"
        fillRule="evenodd"
      />
    </svg>
  )
);
CopyIcon.displayName = "CopyIcon";
export default CopyIcon;
